import { Main } from "@/components/Main";
import { CreateLoaderTable } from "@/components/Loaders";
import { TableData } from "@/App/Distributions/Sellers/Table";
import { useEffect, useState } from "react";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { getContestssData } from "@/Api/contests";
import { useAuth } from "@/hooks/auth";

type ApiDataProps = {
  current_page: number;
  data: any[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: { url?: string; label: string; active: boolean }[];
  next_page_url?: string;
  path: string;
  per_page: number;
  prev_page_url?: string;
  to: number;
  total: number;
};

type TypePageActions = {
  search: (search: string) => void;
  previous: () => void;
  next: () => void;
  lastPage: () => void;
  updateData: () => void;
};

export const PageList = () => {
  const { hasPermission } = usePermissions();
  const [page, setPage] = useState<number>(1);
  const [dataApi, setDataApi] = useState<ApiDataProps>();
  const [state, setState] = useState<"loading" | "loaded" | "error">("loading");
  const unityId = useAuth()?.user?.unity?.[0]?.id || null;

  useEffect(() => {
    fetchData();
  }, [page]);

  const fetchData = async () => {
    setState("loading");
    try {
      const { data } = await getContestssData(page, { contest_status_id: 1, is_active: 1});
      if (data) {
        setDataApi(data.response);
        setState("loaded");
      }
    } catch (error) {
      setState("error");
      console.error("Erro ao buscar concursos:", error);
    }
  };

  const pageActions: TypePageActions = {
    search: () => {},
    previous: () => setPage((prev) => prev - 1),
    next: () => setPage((prev) => prev + 1),
    lastPage: () => dataApi?.last_page && setPage(dataApi.last_page),
    updateData: fetchData,
  };

  return (
    <Main>
      <If condition={hasPermission("view-distributions-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Distribuição para Vendedores
          </h2>
        </div>
        <div className="flex flex-col gap-3">
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData dataApi={dataApi} pageActions={pageActions} unityId={unityId} />
          )}
        </div>
      </If>
    </Main>
  );
};